export interface MenuItem {
    title: string
    href: string
    icon: string
    id: string
    isLinkInDrawer: boolean
    children?: Categories[]
    hideOnMobile?: boolean
}
interface Category {
    title: string
    href: string
    useHrefWithoutParent?: boolean
    links?: SubLink[]
}

export interface Categories {
    categories: Category[]
}

export interface SubLink {
    title: string
    href: string
    useHrefWithoutParent?: boolean
}

export interface UserInfo {
    id: string
    firstName: string | null
    lastName: string | null
    mobileNumber: string
    email: string | null
    isEligibleForCartPage: boolean
}

export enum MobileMenuItems {
    SpecialOffer = 'special-offer',
    Brands = 'brands',
    Makeup = 'makeup',
    HairCare = 'hair-care',
    SkinCare = 'skin-care',
    Men = 'Men',
    Perfume = 'perfume',
    PersonalHygiene = 'personal-hygiene',
    Appliancese = 'appliances',
    Drug = 'drug',
    Apparel = 'apparel',
    ElectronicDevices = 'electronic-devices',
    goldSilver = 'gold-silver',
    kidsCare = 'kids-care',
    Mag = 'mag',
    MagicBox = 'magic-box',
}

export interface SubMennuItem {
    title: string
    icon: string
    id: MobileMenuItems
}

export interface SelectedMenuItem {
    id: string
    title: string
    href: string
    subMenuChildren?: Categories[]
}
